const win = window;
{
  win.o_global || (win.o_global = {});
  win.o_util || (win.o_util = {});
}
const { o_util } = win;
const otto = win.otto ?? {};
const components = otto.components;
export {
  components as c,
  o_util as o,
  win as w
};
/*                                                  */
